import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./authform.component.css";

const ForgotPasswordComponent = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const API_BASE = "http://localhost:8082/api/seo-user";

  // STEP 1 : Send OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email) {
      setError("Email is required");
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${API_BASE}/changePasswordOtp`,
        null,
        { params: { username: email } }
      );

      setMessage(response.data || "OTP sent to your registered email.");
      setStep(2);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to send OTP.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // STEP 2 : Validate OTP + Reset Password
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!otp || !newPassword || !confirmPassword) {
      setError("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    const payload = {
      userName: email,
      otp: otp,
      newPassword: newPassword
    };

    setIsLoading(true);
    try {
      const response = await axios.post(`${API_BASE}/validateOtp`, payload);

      setMessage(response.data || "Password reset successfully!");
      setStep(1);
      setEmail("");
      setOtp("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to reset password.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center cs-color">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-lg border-0 cs-br-20">
              <div className="card-body p-5">

                <div className="text-center mb-4">
                  <img
                    src="/logo1.png"
                    alt="ElexytSEO"
                    width="80"
                    height="60"
                    className="mb-3"
                  />
                  <h2 className="fw-bold text-dark mb-2">Forgot Password</h2>
                  <p className="text-muted">
                    {step === 1
                      ? "Enter your registered email to receive OTP"
                      : "Enter OTP and new password"}
                  </p>
                </div>

                {message && <div className="alert alert-success">{message}</div>}
                {error && <div className="alert alert-danger">{error}</div>}

                {/* STEP 1 – Email */}
                {step === 1 && (
                  <form onSubmit={handleSendOtp}>
                    <div className="mb-4">
                      <input
                        type="email"
                        placeholder="Registered email"
                        className="form-control cs-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isLoading}
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn w-100 py-3 mb-3 cs-sendbtn"
                      disabled={isLoading}
                    >
                      {isLoading ? "Sending..." : "Send OTP"}
                    </button>
                  </form>
                )}

                {/* STEP 2 – OTP + New Password */}
                {step === 2 && (
                  <form onSubmit={handleResetPassword}>
                    <div className="mb-3">
                      <input
                        type="text"
                        placeholder="Enter OTP"
                        className="form-control cs-input"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        disabled={isLoading}
                      />
                    </div>

                    <div className="mb-3">
                      <input
                        type="password"
                        placeholder="New Password"
                        className="form-control cs-input"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        disabled={isLoading}
                      />
                    </div>

                    <div className="mb-3">
                      <input
                        type="password"
                        placeholder="Confirm Password"
                        className="form-control cs-input"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        disabled={isLoading}
                      />
                    </div>

                    <button
                      type="submit"
                      className="btn w-100 py-3 mb-3 cs-sendbtn"
                      disabled={isLoading}
                    >
                      {isLoading ? "Processing..." : "Reset Password"}
                    </button>
                  </form>
                )}

                <div className="text-center mt-4">
                  <Link to="/login" className="text-decoration-none cs-link-color">
                    <i className="fas fa-arrow-left me-2"></i>
                    Back to Login
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordComponent;
